function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#355D96;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M19,0H0v15.4h19V0z M18,1v5.9l-1.6-1.2C15.4,5,14,5.1,13.1,6l-2.3,2.3C10,9,8.8,9.1,7.9,8.5L7,7.8 C6.2,7.2,5,7.2,4.2,7.8L1,9.8V1H18z M1,14.4V11l3.7-2.4c0.5-0.3,1.2-0.3,1.7,0.1l0.8,0.6c1.3,1,3.2,0.8,4.3-0.3l2.3-2.3 c0.5-0.5,1.4-0.6,2-0.2L18,8.1l0,0v6.3H1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M9.1,6.5c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2s-2,0.9-2,2C7.1,5.5,8,6.5,9.1,6.5z M9.1,3.4c0.6,0,1,0.5,1,1 s-0.4,1-1,1s-1-0.5-1-1S8.5,3.4,9.1,3.4z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "20.9,1.2 20.9,17.3 2.1,17.3 2.1,18.3 21.9,18.3 21.9,1.2  "
}));

var SvgPhoto = function SvgPhoto(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.9 18.3",
    style: {
      enableBackground: "new 0 0 21.9 18.3"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/photo.48923a32.svg";
export { ForwardRef as ReactComponent };